import React, { useEffect, useState } from 'react';
import axios from "../../api/axios";
import moment from 'moment';

const TransferReversalHistory = ({ transferId, onClose }) => {
    const [reversals, setReversals] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (transferId) {
            axios.get(`/bank-transactions/${transferId}/reversal-history`)
                .then(res => setReversals(res.data))
                .catch(err => console.error('Failed to load reversal history', err))
                .finally(() => setLoading(false));
        }
    }, [transferId]);

    return (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center p-4">
            <div className="bg-white max-w-3xl w-full rounded-lg shadow-lg overflow-auto max-h-[90vh]">
                <div className="flex justify-between items-center p-4 border-b">
                    <h2 className="text-lg font-bold">Reversal History for Transfer #{transferId}</h2>
                    <button className="text-red-600 font-semibold" onClick={onClose}>×</button>
                </div>

                <div className="p-4">
                    {loading ? (
                        <p>Loading...</p>
                    ) : reversals.length === 0 ? (
                        <p className="text-gray-500">No reversal history found.</p>
                    ) : (
                        <table className="w-full text-sm border">
                            <thead className="bg-blue-800 text-white">
                                <tr>
                                    <th className="border px-2 py-1 text-left">Bank</th>
                                    <th className="border px-2 py-1 text-left">Related Bank</th>
                                    <th className="border px-2 py-1 text-center">Type</th>
                                    <th className="border px-2 py-1 text-right">Amount</th>
                                    <th className="border px-2 py-1 text-center">Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {reversals.map((r) => (
                                    <tr key={r.id} className="odd:bg-white even:bg-gray-100">
                                        <td className="border px-2 py-1">{r.bank_name}</td>
                                        <td className="border px-2 py-1">{r.related_bank_id}</td>
                                        <td className="border px-2 py-1 text-center capitalize">{r.type}</td>
                                        <td className="border px-2 py-1 text-right">{Number(r.amount).toFixed(2)}</td>
                                        <td className="border px-2 py-1 text-center">
                                            {moment(r.transaction_date).format('DD-MM-YYYY hh:mm A')}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}
                </div>
            </div>
        </div>
    );
};

export default TransferReversalHistory;